import moment from "moment";
import React, { useState } from "react";
import { Button, Row, Col, Form, Modal, Spinner, Alert } from "react-bootstrap";
import DatePicker from "react-datepicker";
import { formatDate } from "../../../utils";


const CancelSubscription = ({ show, handleClose, subscription, handleSuccess }) => {
    const [formData, setFormData] = useState({ values: { endDate: new Date() }, errors: {} });
    const [submitting, setSubmitting] = useState(false);
    const [apiError, setApiError] = useState(undefined);

    const handleChange = (field, value) => {
        setFormData((prevFormData) => {
            const { values: prevValues } = prevFormData;
            return {
                ...prevFormData,
                values: { ...prevValues, [field]: value }
            }
        });
    }

    const onSubmit = async () => {
        const { values: data } = formData;
        const sanitizedData = {
            userSubscriptionId: subscription?.id,
            endDate: moment(data?.endDate).format("YYYY-MM-DD"),
            notes : data?.notes
        };
        try {
            setSubmitting(true);
            setApiError(undefined);
            await handleSuccess(sanitizedData);
            setSubmitting(false);
        } catch (e) {
            setApiError(e?.message || "System error");
            setSubmitting(false);
            console.log(e)
        }

    }
    const subsTimeZone = subscription?.subscriptionType?.timezone;
    return (
        <Modal show={show} onHide={handleClose} size="lg">
            <Modal.Header closeButton>
                <Modal.Title>Cancel Subscription {subscription.subscriptionType.name}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form>
                    <Alert variant="warning">
                    Are you sure you want to cancel the subscription?
                    </Alert>
                    <Col className="mb-5">
                        The subscription will 
                        continue to be active until {formatDate(subscription?.validityEndDate, subsTimeZone, "DD MMM YYYY z")}.
                    </Col>
                    <Form.Group as={Row} className="mb-3" controlId="frmEndDate">
                        <Form.Label column sm={3}>End Date*</Form.Label>
                        <Col sm={9}>
                            <DatePicker
                                dateFormat="dd/MM/yyyy"
                                selected={formData?.values?.endDate}
                                onChange={(date) => handleChange('endDate', date)}
                            />
                             {formData?.errors?.endDate && (<span className="error-text">
                                {formData?.errors?.endDate}
                            </span>)}
                        </Col>
                    </Form.Group>
                    <Form.Group as={Row} className="mb-3" controlId="frmNotes">
                        <Form.Label column sm={3}>
                            Notes
                        </Form.Label>
                        <Col sm={9}>
                            <Form.Control
                                type="text" as={'textarea'} rows={2} placeholder=""
                                value={formData?.values?.notes || ''}
                                onChange={(e) => handleChange('notes', e.target.value)}
                                isInvalid={formData?.errors?.notes}
                            />
                            {formData?.errors?.notes && (<span className="error-text">
                                {formData?.errors?.notes}
                            </span>)}
                        </Col>
                    </Form.Group>
                </Form>
                <div style={{fontSize : 14}}>
                    End Date is the date that the customer requested to cancel their 
                    subscription.<br/>The Validity Date is the last date their subscription 
                    is active and will be assigned automatically.
                </div>
                {apiError && (
                    <Alert variant="danger">{apiError}</Alert>
                )}
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={handleClose}>
                    Close
                </Button>
                <Button variant="primary" onClick={onSubmit} disabled={submitting}>
                    {submitting && <Spinner
                        as="span"
                        animation="grow"
                        size="sm"
                        role="status"
                        aria-hidden="true"
                    />}
                    Cancel Subscription
                </Button>
            </Modal.Footer>
        </Modal>
    )
}

export default CancelSubscription;